<script>
import * as api from '@/api';
import * as utility from '@/utility';

// Views Mixin
export default {
  methods: {
    isAdmin() { return utility.isAdmin(this.$store.state.role); },
    isAgent() { return utility.isAgent(this.$store.state.role); },
    isSeller() { return utility.isSeller(this.$store.state.role); },
    updateTitle(value) {  this.$emit('updateTitle', value);  },
  },
};
</script>
